import * as R from 'ramda';
import { AppState } from './appState';
import { ActionType } from './actionType';
import { Action } from 'redux';


type UpdateStateAction = {
  type: ActionType.UpdateStateAction;
  newState: Partial<AppState>;
}


/**
 * Generally, you don't want to use this action, but it's useful in a handful of circumstances.
 * Deep-merges the state given here onto the current app state.
 */
export const updateStateAction = (
  newState: Partial<AppState>,
): UpdateStateAction => ({
  type:     ActionType.UpdateStateAction,
  newState: newState,
});


export const updateStateReducer = (state: AppState, action: Action): AppState => {
  if (action.type !== ActionType.UpdateStateAction) {
    return state;
  }

  return R.mergeDeepRight(state, (action as UpdateStateAction).newState) as AppState;
};
